/**
 * Single abstraction for accessing NX_* environment settings.
 *
 * Sources, checked per key:
 * - window.__env[key] (populated by Docker entrypoint in container mode; may be
 *   an empty stub on the SWA path, which is why the fallback is per-key not all-or-nothing)
 * - process.env[key] (webpack DefinePlugin — baked at build time on SWA and nx serve)
 *
 * By default, throws if the key is not found in either source.
 * Pass { optional: true } for settings that may legitimately be absent.
 *
 * Direct process.env.NX_* access in feature code is banned. Use envSettings() instead.
 */

interface EnvSettingsOptions {
  optional?: boolean;
}

export function envSettings(key: string, options?: EnvSettingsOptions): string | undefined {
  const value = (window as any).__env?.[key] ?? process.env?.[key] ?? undefined;

  if (value === undefined && !options?.optional) {
    throw new Error(`Missing required environment setting: ${key}`);
  }

  return value;
}
